import { Component, OnInit, Input, ViewChildren } from "@angular/core";
import { IonInput, ModalController, NavParams } from "@ionic/angular";
//import { Validators, FormBuilder, FormGroup } from "@angular/forms";

/*import localeCO from "@angular/common/locales/es-CO";
import { registerLocaleData } from "@angular/common";
registerLocaleData(localeCO, "CO");*/
//import { CurrencyPipe } from "@angular/common";

import { HttpClient } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { userInfo } from "os";

@Component({
  selector: "app-epayco",
  templateUrl: "./epayco.page.html",
  styleUrls: ["./epayco.page.scss"],
})
export class EpaycoPage implements OnInit {
  monto: number;
  descripcion: string;
  mediosPago: any[] = []; // Inicialización segura
  paymentForm: FormGroup;
  montoFormat;
  opcionMedioPago = true;
  continuar = true;
  pasofinal = false;
  cuotas: any = [];

  public bancosE: any = [];
  setCuota: number = 1;
  isEcomerce: boolean = false;
  isFrecuente: boolean = false;
  tiposDocumento: any[] = [
    { id: "CC", descripcion: "Cédula de Ciudadanía" },
    { id: "CE", descripcion: "Cédula de Extranjería" },
    { id: "PA", descripcion: "Pasaporte" },
    { id: "NIT", descripcion: "Nit" }
  ];

  constructor(
    public modalCtrl: ModalController,
    public navParams: NavParams,
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.formPayment();
    this.monto = this.navParams.get("monto");
    this.descripcion = this.navParams.get("descripcion");
    this.isEcomerce = this.navParams.get("isEcomerce");
    if (this.navParams.get("bancos")) {
      let bancos: any = JSON.parse(
        JSON.stringify(this.navParams.get("bancos"))
      );

      bancos.forEach((element, i) => {
        let r = element.bankName.replace(/\\u(....)/gi, function (m, v) {
          return String.fromCharCode(parseInt(v, 16));
        });
        this.bancosE.push({ bankName: r, bankCode: element.bankCode });
        this.bancosE = this.bancosE.filter((x) => x.bankCode != 0);
        //this.bancosE.push({'bankName':r,'bankCode':'1022'});
      });
    }

    //this.montoFormat = this.getCurrency(this.monto);
    this.montoFormat = this.monto;
    //console.log(this.bancosE);
  }

  formPayment() {
    this.paymentForm = this.fb.group({
      nombre: [this.navParams.get("nombreapellido"), Validators.required],
      email: [
        this.navParams.get("correo"),
        [Validators.required, Validators.email],
      ],
      tipoDocumento: ["", [Validators.required]],
      identificacion: [
        this.navParams.get("identificacion"),
        Validators.required,
      ],
      movil: [
        this.navParams.get("telefono"),
        [Validators.required, Validators.pattern("[0-9]{10}")],
      ],
      cardnumber: ["", [Validators.pattern("[0-9]{15,16}")]],
      cardexp_month: ["", [Validators.pattern("([1][0-2]|[0][1-9])")]],
      cardexp_year: [
        "",
        [Validators.pattern("([2][0][2-9][1-9]|[2][0-9][0-9][0-9])")],
      ],
      cardcvc: ["", [Validators.pattern("[0-9]{3}")]],
      cuota: [""],
      pais: ["Colombia"],
      ciudad: [this.navParams.get("ciudad"), [Validators.required]],
      direccion: [this.navParams.get("direccion"), [Validators.required]],
      codeBank: [null],
    });
  }

  pagoEfetivo: string = "";

  credit_infoForm = {
    cardnumber: "",
    cardexp_year: "",
    cardexp_month: "",
    cardcvc: "",
  };

  ngOnInit() {
    for (let i = 0; i < 36; i++) {
      this.cuotas.push({ value: i + 1 });
    }
    this.mediosPago = [
      {
        id: 1,
        activa: false,
        isFrecuente: true,
        texto: "Tarjeta de Crédito y Débito",
        img: "assets/imagenes/sistema/credit.svg",
      },
      {
        id: 2,
        activa: false,
        isFrecuente: this.isFrecuente ? false : true,
        texto: "Cuentas de ahorro y corriente",
        img: "assets/imagenes/sistema/pse.svg",
      },
      {
        id: 3,
        activa: false,
        isFrecuente: this.isFrecuente ? false : true,
        texto: "Efectivo",
        img: "assets/imagenes/sistema/mbricash.svg",
      },
    ];
    if (this.isFrecuente) {
      this.setPago(1);
    }
  }
  pagos_efectivos = [
    {
      id: 1,
      activa: false,
      texto: "Efecty",
      texcode: "efecty",
      img: "efecty.png",
    },
    {
      id: 2,
      activa: false,
      texto: "Gana",
      texcode: "gana",
      img: "gana.png",
    },
    {
      id: 3,
      activa: false,
      texto: "Baloto",
      texcode: "baloto",
      img: "baloto.png",
    },
    {
      id: 4,
      activa: false,
      texto: "Puntored",
      texcode: "puntored",
      img: "puntored.png",
    },
    {
      id: 5,
      activa: false,
      texto: "Redservi",
      texcode: "redservi",
      img: "redservi.png",
    },
  ];

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      dismissed: false,
    });
  }
  aceptarEpayco() {
    if (this.paymentForm.valid) {
      let mediosPago = this.mediosPago.find((x) => x.activa === true).id;
      let credit_info = {
        "card[number]": this.paymentForm.get("cardnumber").value + "",
        "card[exp_year]": this.paymentForm.get("cardexp_year").value + "",
        "card[exp_month]": this.paymentForm.get("cardexp_month").value + "",
        "card[cvc]": this.paymentForm.get("cardcvc").value + "",
      };
      this.modalCtrl.dismiss({
        dismissed: true,
        credit_info: credit_info,
        cuotas: this.setCuota,
        codebank: this.paymentForm.get("codeBank").value,
        mediosPago: mediosPago,
        pagoEfetivo: this.pagoEfetivo,
        payInfo: this.paymentForm.value,
        descripcion: this.descripcion,
        monto: this.monto,
      });
    }
    this.paymentForm.markAllAsTouched();
  }

  getCurrency(amount: number) {
    //return this.currencyPipe.transform(amount, "$", true, "1.0-0");
    return amount;
  }

  //continuar = true;
  //pasofinal = false;
  setPago(id) {
    this.mediosPago.forEach((element) => {
      if (element.id == id) {
        element.activa = true;
        this.opcionMedioPago = false;
      } else {
        element.activa = false;
      }
    });
    let inputs = [
      "cardnumber",
      "cardexp_month",
      "cardexp_year",
      "cardcvc",
      "cuota",
      "pais",
      "ciudad",
      "codeBank",
    ];
    if (id == 1) {
      inputs.forEach((element) => {
        this.paymentForm.get(element).setValidators(Validators.required);
      });
      // this.paymentForm.get("pais").disable();
      // this.paymentForm.get("ciudad").disable();
    } else {
      inputs.forEach((element) => {
        this.paymentForm.get(element).clearValidators();
      });
    }
    if (id == 2) {
      this.paymentForm.get("codeBank").setValidators(Validators.required);
    } else {
      this.paymentForm.get("codeBank").clearValidators();
    }
    this.paymentForm.updateValueAndValidity();
    this.paymentForm.markAllAsTouched();
  }
  continuarPaso() {
    let campos = [
      "movil",
      "cardnumber",
      "cardexp_month",
      "cardexp_year",
      "cardcvc",
      "cuota",
    ];
    if (campos.every((campo) => this.paymentForm.get(campo).valid)) {
      this.continuar = false;
      this.pasofinal = true;
      return;
    } else {
      this.paymentForm.markAllAsTouched();
    }
  }
  cambiarMedioPago() {
    this.mediosPago.forEach((element) => {
      element.activa = false;
    });
    this.opcionMedioPago = true;
    this.continuar = true;
    this.pasofinal = false;
  }

  getCuota(event) {
    this.setCuota = event.detail.value;
  }

  checkNumCard(event) {
    let valor = this.credit_infoForm.cardnumber;
    let pattern = /^\d{16,16}$/;
    let result = pattern.test(valor);
    if (!result) {
    }
  }

  numericOnly(event): boolean {
    let pattern = /^([0-9])$/;
    let result = pattern.test(event.key);
    return result;
  }

  medioActivo(id) {
    this.pagos_efectivos.forEach((element, i) => {
      if (element.id == id) {
        element.activa = true;
        this.pagoEfetivo = element.texcode;
      } else {
        element.activa = false;
      }
    });
  }

  logoData: any = [];
  imgLogo = null;
  loadLocalAssetToBase64(path) {
    this.http.get(path, { responseType: "blob" }).subscribe((res) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        let imgBase64 = reader.result;
        this.logoData.push(imgBase64);
      };
      reader.readAsDataURL(res);
    });
  }
}
